import React from 'react'
import { defaultProps } from 'recompose'
import { Input } from 'reactstrap'
import { addNotification } from 'reapop'
import {
  CALL_API,
  COUNT_DETECTOR,
  createSelectorForEntityKey,
  createEntitiesSelector,
  createIdsSelector,
  getApiState,
} from '@infotech/lib-api-middleware'
import { DropdownList, Combobox, Spinner } from '@infotech/base-components'
import { createNotifyConf } from '@infotech/notify'
import { PrimaryButton, SecondaryButton } from '@infotech/uikit-button'

import { REACT_APP_REFERENSE_PASSPORT } from 'api/constants'
import {
  geoCodingFetch, geoCodingSelector, geoKeyFun, geoCodingEntitiesSelector,
} from 'api/geoCoding'

import './equipment-field.scss'
import ModalDialog from './ModalDialog'
import Pagination from './Pagination'

const Label = ({ children }) => (
  <div>
    { children }
  </div>
)

const dependencies = {
  referencePath          : `${REACT_APP_REFERENSE_PASSPORT}`,
  referenceDataChangePath: `/passport-reference-data-change-request-service`,

  limitSelectedEquipment: 1,

  CALL_API,
  COUNT_DETECTOR,
  createSelectorForEntityKey,
  createEntitiesSelector,
  createIdsSelector,
  getApiState,

  Input,
  Label,
  DropdownList,
  Combobox: defaultProps({ filter: false })(Combobox),
  PrimaryButton,
  SecondaryButton,
  Spinner,

  ModalDialog,
  Pagination,

  errorNotificationAction  : (message) => addNotification(createNotifyConf(message, `error`)),
  successNotificationAction: (message) => addNotification(createNotifyConf(message, `success`)),

  geocodingFetch           : geoCodingFetch,
  geoKeyFun,
  geocodingSelector        : geoCodingSelector,
  geocodingEntitiesSelector: geoCodingEntitiesSelector,
}

export default dependencies
